function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * dd-gridstack.ts 10.3.1
 * Copyright (c) 2021 Alain Dumesny - see GridStack root license
 */
import { Utils } from './utils';
import { DDManager } from './dd-manager';
import { DDElement } from './dd-element';
// let count = 0; // TEST
/**
 * HTML Native Mouse and Touch Events Drag and Drop functionality.
 */
export var DDGridStack = /*#__PURE__*/function () {
  function DDGridStack() {
    _classCallCheck(this, DDGridStack);
  }
  return _createClass(DDGridStack, [{
    key: "resizable",
    value: function resizable(el, opts, key, value) {
      this._getDDElements(el).forEach(function (dEl) {
        if (opts === 'disable' || opts === 'enable') {
          dEl.ddResizable && dEl.ddResizable[opts](); // can't create DD as it requires options for setupResizable()
        } else if (opts === 'destroy') {
          dEl.ddResizable && dEl.cleanResizable();
        } else if (opts === 'option') {
          dEl.setupResizable(_defineProperty({}, key, value));
        } else {
          var n = dEl.el.gridstackNode;
          var grid = n.grid;
          var handles = dEl.el.getAttribute('gs-resize-handles') || grid.opts.resizable.handles || 'e,s,se';
          if (handles === 'all') handles = 'n,e,s,w,se,sw,ne,nw';
          // NOTE: keep the resize handles as e,w don't have enough space (10px) to show resize corners anyway. limit during drag instead
          // restrict vertical resize if height is done to match content anyway... odd to have it spring back
          // if (Utils.shouldSizeToContent(n, true)) {
          //   const doE = handles.indexOf('e') !== -1;
          //   const doW = handles.indexOf('w') !== -1;
          //   handles = doE ? (doW ? 'e,w' : 'e') : (doW ? 'w' : '');
          // }
          var autoHide = !grid.opts.alwaysShowResizeHandle;
          dEl.setupResizable(_objectSpread(_objectSpread(_objectSpread({}, grid.opts.resizable), {
            handles: handles,
            autoHide: autoHide
          }), {
            start: opts.start,
            stop: opts.stop,
            resize: opts.resize
          }));
        }
      });
      return this;
    }
  }, {
    key: "draggable",
    value: function draggable(el, opts, key, value) {
      this._getDDElements(el).forEach(function (dEl) {
        if (opts === 'disable' || opts === 'enable') {
          dEl.ddDraggable && dEl.ddDraggable[opts](); // can't create DD as it requires options for setupDraggable()
        } else if (opts === 'destroy') {
          dEl.ddDraggable && dEl.cleanDraggable();
        } else if (opts === 'option') {
          dEl.setupDraggable(_defineProperty({}, key, value));
        } else {
          var grid = dEl.el.gridstackNode.grid;
          dEl.setupDraggable(_objectSpread(_objectSpread({}, grid.opts.draggable), {
            // containment: (grid.parentGridItem && grid.opts.dragOut === false) ? grid.el.parentElement : (grid.opts.draggable.containment || null),
            start: opts.start,
            stop: opts.stop,
            drag: opts.drag
          }));
        }
      });
      return this;
    }
  }, {
    key: "dragIn",
    value: function dragIn(el, opts) {
      this._getDDElements(el).forEach(function (dEl) {
        return dEl.setupDraggable(opts);
      });
      return this;
    }
  }, {
    key: "droppable",
    value: function droppable(el, opts, key, value) {
      if (typeof opts.accept === 'function' && !opts._accept) {
        opts._accept = opts.accept;
        opts.accept = function (el) {
          return opts._accept(el);
        };
      }
      this._getDDElements(el).forEach(function (dEl) {
        if (opts === 'disable' || opts === 'enable') {
          dEl.ddDroppable && dEl.ddDroppable[opts]();
        } else if (opts === 'destroy') {
          if (dEl.ddDroppable) {
            // error to call destroy if not there
            dEl.cleanDroppable();
          }
        } else if (opts === 'option') {
          dEl.setupDroppable(_defineProperty({}, key, value));
        } else {
          dEl.setupDroppable(opts);
        }
      });
      return this;
    }
    /** true if element is droppable */
  }, {
    key: "isDroppable",
    value: function isDroppable(el) {
      return !!(el && el.ddElement && el.ddElement.ddDroppable && !el.ddElement.ddDroppable.disabled);
    }
    /** true if element is draggable */
  }, {
    key: "isDraggable",
    value: function isDraggable(el) {
      return !!(el && el.ddElement && el.ddElement.ddDraggable && !el.ddElement.ddDraggable.disabled);
    }
    /** true if element is draggable */
  }, {
    key: "isResizable",
    value: function isResizable(el) {
      return !!(el && el.ddElement && el.ddElement.ddResizable && !el.ddElement.ddResizable.disabled);
    }
  }, {
    key: "on",
    value: function on(el, name, callback) {
      this._getDDElements(el).forEach(function (dEl) {
        return dEl.on(name, function (event) {
          callback(event, DDManager.dragElement ? DDManager.dragElement.el : event.target, DDManager.dragElement ? DDManager.dragElement.helper : null);
        });
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(el, name) {
      this._getDDElements(el).forEach(function (dEl) {
        return dEl.off(name);
      });
      return this;
    }
    /** @internal returns a list of DD elements, creating them on the fly by default */
  }, {
    key: "_getDDElements",
    value: function _getDDElements(els) {
      var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var hosts = Utils.getElements(els);
      if (!hosts.length) return [];
      var list = hosts.map(function (e) {
        return e.ddElement || (create ? DDElement.init(e) : null);
      });
      if (!create) {
        list.filter(function (d) {
          return d;
        });
      } // remove nulls
      return list;
    }
  }]);
}();